import { BUTTON_CLASS, ButtonVariant } from '.';

export const getButtonStyleClass = (
  variant: ButtonVariant,
  disabled: boolean,
) => {
  if (disabled) return BUTTON_CLASS.DISABLED;

  switch (variant) {
    case ButtonVariant.Success:
      return BUTTON_CLASS.SUCCESS;
    case ButtonVariant.Primary:
      return BUTTON_CLASS.PRIMARY;
    case ButtonVariant.Secondary:
      return BUTTON_CLASS.SECONDARY;
    case ButtonVariant.Danger:
      return BUTTON_CLASS.DANGER;
    case ButtonVariant.Grayscale:
      return BUTTON_CLASS.GRAYSCALE;
  }
};
